module.exports = __webpack_public_path__ + "static/img/(1958)_05_25_VillageVanguard_Program.d1b5a8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/thumbs/(1958)_05_25_VillageVanguard_Program.jpg
// module id = CDCG
// module chunks = 0